'use client';

import { Images } from '@/assets/imgs';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import Chart from './Chart';
import axios from 'axios';

export const Elite = () => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);

  return (
    <div className="prometheus-elite">
      <Image
        src={Images.prometheusNFT.fern}
        className="fern"
        width={656 / 4}
        height={1584 / 4}
        quality={100}
        alt="fern"
      />
      <Image
        src={Images.prometheusNFT.beetle}
        className="beetle"
        width={1130 / 4}
        height={968 / 4}
        quality={100}
        alt="beetle"
      />
      <Image
        src={Images.prometheusNFT.alphie}
        className="alphie lg"
        width={780 / 4}
        height={920 / 4}
        quality={100}
        alt="aplhie"
      />

      <Image
        src={Images.prometheusNFT.alphieSm}
        className="alphie sm"
        width={780 / 4}
        height={920 / 4}
        quality={100}
        alt="aplhie"
      />
      <div className="container">
        <ObserverContainer className="flex column head">
          <h2 className="integralfc-h2 reveal-from-bottom" ref={ref}>
            ELITE WEB3 CLUB
          </h2>
          <p>
            Experience the best whitelist, early access and alpha from our
            network of partners and games.
          </p>
        </ObserverContainer>

        <div className="cards">
          <div className="card">
            <div className="top">
              <div className="red">EARLY-ACCESS</div>
              <h3 className="integralfc-h3 reveal-from-bottom" ref={ref}>
                GAMES
              </h3>
            </div>

            <div className="icons">
              <Image
                quality={100}
                width={72}
                height={46}
                src={Images.prometheusNFT.bigTime}
                alt="big time"
              />
              <Image
                quality={100}
                width={124}
                height={24}
                src={Images.prometheusNFT.parallel}
                alt="parallel"
              />
              <Image
                quality={100}
                width={64}
                height={40}
                src={Images.prometheusNFT.metalCore}
                alt="metal core"
              />
              <Image
                quality={100}
                width={118}
                height={25}
                src={Images.prometheusNFT.aurory}
                alt="aurory"
              />
              <Image
                quality={100}
                width={111}
                height={29}
                src={Images.prometheusNFT.illuvium}
                alt="illuvium"
              />
            </div>
          </div>
          <div className="card card-2">
            <div className="top">
              <div className="red">EXCLUSIVE WHITELISTS</div>
              <h3 className="integralfc-h3 reveal-from-bottom" ref={ref}>
                NFT
              </h3>
            </div>

            <div className="icons">
              <Image
                quality={100}
                width={145}
                height={33}
                src={Images.prometheusNFT.sharapnel}
                alt="sharapnel"
              />
              <Image
                quality={100}
                width={110}
                height={38}
                src={Images.prometheusNFT.citizenConflict}
                alt="citizen conflict"
              />
              <Image
                quality={100}
                width={145}
                height={32}
                src={Images.prometheusNFT.aneemate}
                alt="aneemate"
              />
              <Image
                quality={100}
                width={95}
                height={43}
                src={Images.prometheusNFT.xociety}
                alt="xociety"
              />
            </div>
          </div>
        </div>

        {/* <div className="history">
          <ObserverContainer className="flex column head">
            <h2 className="integralfc-h2 reveal-from-bottom" ref={ref}>
              PRICE HISTORY{' '}
              <Image
                src={Images.prometheusNFT.info}
                width={24}
                height={24}
                alt="info"
              />
            </h2>
          </ObserverContainer>

          <Chart />
        </div> */}
      </div>
    </div>
  );
};
